import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const referrerKey = 'preisradar_initial_referrer';
if (!sessionStorage.getItem(referrerKey)) {
  sessionStorage.setItem(referrerKey, document.referrer || '');
}
console.log('[Preisradar] Referrer:', sessionStorage.getItem(referrerKey) || '(kein Referrer)');

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
